/* eslint-disable no-nested-ternary */
import React, { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import styled from "styled-components";
import Box from "@mui/material/Box";
import Datetime from "react-datetime";
import moment from "moment-timezone";
import "react-datetime/css/react-datetime.css";
import LinearProgress from "@mui/material/LinearProgress";
import { useDispatch, useSelector } from "react-redux";
import {
    SUPERADMIN_ROLE,
    ADMIN_ROLE,
    LOG_EVENTS_AVATAR_SELECTION,
    DEFAULT_QUERY_OPTIONS,
    LOG_EVENTS_DEVICE_DATA,
    LOG_EVENTS_USER_LOGIN_DATA,
} from "../../constants";
import { SaveVanityLink } from "../../redux/actions/VanityLinkActions";
import { fetchVanityLinkData, sendAutoLoginLink, fetchVanityLinkBySlug } from "../../api/VanityLinkController";
import { fetchUserId, fetchUserToken } from "../../redux/slices/users";
import { ReactComponent as PinkIntraverseLogoIcon } from "../../assets/images/logos/pink_intraverse_logo.svg";
import BackgroundContainer from "../../components/common/Backgrounds/BackgroundContainer";
import { setColor, setFont } from "../../assets/styles/styles";
import BirthdayIcon from "../../assets/images/icons/UC_Sprite_Icon_Birthday.png";
import Typography from "../../components/common/text/Typography";
import { Input } from "../../components/common/input/Input";
import PasswordChecker from "../login/PasswordChecker";
import AuthSocial from "../../api/AuthSocial";
import {
    LogInWithEmail,
    sendEventsLog,
    emailExistsChecker,
    ageChecker,
    RegisterUser,
    RegisterGuestUser,
    forgotPasswordEmail,
    UpdateUserProfileData,
} from "../../api/UserController";
import { DeleteUser, SaveUser } from "../../redux/actions/UserActions";
import { SaveMerchant } from "../../redux/actions/MerchantActions";
import Iconify from "../../components/common/icon/Iconify";
import { CheckBoxMain } from "../../components/common/checkBox/CheckBoxMain";
import Banner from "../../components/layout/ui/Banner";

import {
    isValidEmail,
    nameValidation,
    passwordValidator,
    updateUrlWithVanity,
    getFileType,
    getDeviceInfo,
} from "../../utils/generalUtils";
import { useStreaming } from "../../context/StreamingContext";
import Button from "../../components/common/button/Button";
import VanityAvatarPage from "./VanityAvatarPage";
import RenderStreaming from "../render-stream/RenderStreaming";
import { RoomSettingsProvider } from "../render-stream/RoomSettingsContext";
import VanityURLRedirects from "../../features/vagon/VanityURLRedirects";
import { AuthenticateAutoLogin } from "./helpers/utils";
import IntraverseLetteringLogo from "../../assets/images/logos/Intraverse_Logo_Lettering.svg";
import { getFromSessionStorage, setToSessionStorage } from "../../hooks/useSessionStorage";
import { UpdateUserSettings } from "../../api/AvatarController";

const VanityStartingPage = ({ autoLogin = false, ...props }) => {
    const user = useSelector((state) => state.user);
    const dispatch = useDispatch();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const code = queryParams.get("code");
    const googleSsoData = queryParams.get("googleSsoData");
    const spotifySsoData = queryParams.get("spotifySsoData");

    let pathId = code
        ? window.location.pathname.split("/").pop().split("?")[0]
        : window.location.pathname.split("/").pop();
    const [vanityLinkData, setVanityLinkData] = useState({});
    const [ssoByPass, setSsoByPass] = useState(false);
    const spotifyToken = getFromSessionStorage("spotifyAccessToken");

    const [email, setEmail] = useState("");
    const [backgroundFileType, setBackgroundFileType] = useState("");
    const [password, setPassword] = useState("");
    const [emailExists, setEmailExists] = useState(null);
    const [noUsername, setNoUsername] = useState(false);
    const [birthday, setBirthday] = useState("");
    const [isBirthdayInputValid, setIsBirthdayInputValid] = useState(false);

    const [emailErrorMsg, setEmailErrorMsg] = useState("");
    const [isEmailError, setIsEmailError] = useState(false);
    const [passwordErrorMsg, setPasswordErrorMsg] = useState("");
    const [nameError, setNameError] = useState("");
    const [isNameError, setIsNameError] = useState(false);
    const [isPasswordError, setIsPasswordError] = useState(false);
    const [checkboxErrorMsg, setCheckboxErrorMsg] = useState("");
    const [isCheckboxError, setIsCheckboxError] = useState(false);
    const [spotifyError, setSpotifyError] = useState("");
    const [isBirthdateErr, setIsBirthdateErr] = useState(false);
    const [birthdateErrorMsg, setBirthdateErrorMsg] = useState("");
    const [userAgeErr, setUserAgeErr] = useState(false);
    const [userAgeErrMsg, setUserAgeErrMsg] = useState(false);

    const [spotifyPlayer, setSpotifyPlayer] = useState(null);

    const [loginError, setLoginError] = useState("");
    const [finalAvatar, setFinalAvatar] = useState(null);
    const [isFormSubmitted, setIsFormSubmitted] = useState(false);
    const [sendEmail, setSendEmail] = useState(false);
    const [passwordReset, setPasswordReset] = useState(false);

    // For room ID resolution
    const [resolvedRoomId, setResolvedRoomId] = useState(null);

    const [registerForm, setRegisterForm] = useState(false);
    const [currentScreen, setCurrentScreen] = useState("vanityStartingPage");

    // Form data states
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [username, setUsername] = useState("");
    const [checkboxStatus, setCheckboxStatus] = useState(false);
    const [specialOffers, setSpecialOffers] = useState(false);

    const token = useSelector(fetchUserToken);
    const userId = useSelector(fetchUserId);
    const { isDcvStreaming } = useStreaming();

    const [isLoading, setIsLoading] = useState(true);
    const isRoomInvite = localStorage.getItem("inviteRoomId") || "";
    const inviteSettings = localStorage.getItem("inviteSettings") || "";
    const [alreadyLoggedInMessage, setAlreadyLoggedInMessage] = useState("");
    const [isAlreadyLoggedIn, setIsAlreadyLoggedIn] = useState(false);
    const selectedAvatar = getFromSessionStorage("selectedAvatar");

    const eventsLogForDevice = async (token, pathId, userId) => {
        const deviceInfo = await getDeviceInfo();
        await sendEventsLog(token, pathId, userId, LOG_EVENTS_DEVICE_DATA, "info-vanity", deviceInfo, "", "");
    };

    useEffect(() => {
        if (user && pathId) {
            const justLoggedIn = localStorage.getItem("justLoggedIn");
            const avatarSelected = selectedAvatar !== null && selectedAvatar !== undefined;

            // unique key for this user + pathId
            const deviceInfoKey = `deviceInfoSent_${user.userId}_${pathId}`;
            const deviceInfoSent = sessionStorage.getItem(deviceInfoKey);

            const sendDeviceInfoOnce = async () => {
                if (!deviceInfoSent && user.token && user.userId) {
                    await eventsLogForDevice(user.token, pathId, user.userId);
                    sessionStorage.setItem(deviceInfoKey, "true");
                }
            };

            if ((justLoggedIn === null || !justLoggedIn) && user.email && user.token) {
                setEmail(user.email);
                setNoUsername(true);
                setBirthday(user.userBirthday);
                sendDeviceInfoOnce();
                setIsAlreadyLoggedIn(true);

                if (avatarSelected) {
                    setAlreadyLoggedInMessage(`You are already logged in as ${user.email}, get ready to enter!`);
                    setCurrentScreen("vanityRedirect");
                } else {
                    setAlreadyLoggedInMessage(`You are already logged in as ${user.email}, please select your avatar!`);
                    setCurrentScreen("vanityAvatarScreen");
                }
            }

            if (justLoggedIn || justLoggedIn !== null) {
                localStorage.removeItem("justLoggedIn");
                sessionStorage.removeItem(deviceInfoKey);
            }
        }
    }, [user, pathId]);

    // Adds error messaging after form submit to prevent next page
    const handleEmailData = () => {
        if (!checkboxStatus) {
            setIsCheckboxError(true);
        } else {
            setIsCheckboxError(false);
        }
        if (!passwordValidator(password) && password.length > 0) {
            setIsPasswordError(true);
        } else {
            setIsPasswordError(false);
        }
        if (email !== "" && !isValidEmail(email)) {
            setIsEmailError(true);
        } else {
            setIsEmailError(false);
        }
        if (checkboxStatus && passwordErrorMsg === "" && emailErrorMsg === "") {
            setRegisterForm(true);
        } else {
            setRegisterForm(false);
        }
    };

    const handleRegistrationDataSubmit = async () => {
        if (nameError !== "") {
            setIsNameError(true);
        } else {
            setIsNameError(false);
            setCurrentScreen("vanityAvatarScreen");
        }
    };

    const handleGuestUserData = async () => {
        if (!checkboxStatus) {
            setIsCheckboxError(true);
        } else {
            setIsCheckboxError(false);
        }
        if (email !== "" && !isValidEmail(email)) {
            setIsEmailError(true);
        } else {
            setIsEmailError(false);
        }
        if (checkboxStatus && isValidEmail(email)) {
            setCurrentScreen("vanityAvatarScreen");
        }
    };

    const handleEmailCheck = async (e) => {
        e.preventDefault();
        const emailValue = e.target.value;
        setEmail(emailValue);

        if (emailValue.trim() !== "") {
            setEmail(emailValue);
            const exists = await emailExistsChecker(emailValue.toLowerCase());
            if (exists) {
                const age = await ageChecker(emailValue.toLowerCase());
                if (
                    age &&
                    age.userAge < 21 &&
                    (vanityLinkData.clientName === "bet-mgm" || vanityLinkData.clientName === "playstar")
                ) {
                    setUserAgeErr(true);
                    setUserAgeErrMsg("You must be at least 21 years old to register.");
                } else {
                    setUserAgeErr(false);
                    setUserAgeErrMsg("");
                }
            }
            setEmailExists(exists);
        }
        if (!isValidEmail(emailValue)) {
            setIsEmailError(true);
            setEmailErrorMsg("Please enter a valid email address");
        } else {
            setIsEmailError(false);
            setEmailErrorMsg("");
        }
    };

    useEffect(() => {
        if (firstName.length === 0 || lastName.length === 0) {
            setNameError("Please provide your first and last name");
        } else if (!nameValidation(firstName, lastName)) {
            setNameError("Your name should only contain letters and/or spaces");
        } else {
            setNameError("");
        }
        if (!checkboxStatus) {
            setCheckboxErrorMsg("Please verify that you are over 18 and agree to our terms before proceeding");
        } else {
            setCheckboxErrorMsg("");
        }
        if (!passwordValidator(password) && password.length > 0) {
            setPasswordErrorMsg("Please select a valid password");
        } else {
            setPasswordErrorMsg("");
        }
        if (email !== "" && !isValidEmail(email)) {
            setEmailErrorMsg("Please enter a valid email address");
        } else {
            setEmailErrorMsg("");
        }
    }, [firstName, lastName, email, password, checkboxStatus]);

    useEffect(() => {
        if (code) {
            setCheckboxStatus(true);
            setCurrentScreen("vanityEmailPage");
        }
    }, [email, code]);

    // Retrieves vanity link data and information on url load
    useEffect(() => {
        const authenticateAutoLogin = async () => {
            try {
                const id = queryParams.get("id");
                const access = queryParams.get("access");
                const vanity = queryParams.get("vanity");
                const result = await AuthenticateAutoLogin(id, access, vanity);

                if (!result) {
                    return window.location.replace("/404");
                }

                dispatch(
                    SaveUser(
                        result.data.user.email,
                        result.data.user.displayName,
                        result.data.token,
                        "",
                        result.data.userId,
                        "",
                        false,
                        result.data.expiration,
                        "",
                        result.data.user.userBirthday,
                        result.data.isUserOwnerOfClient
                    )
                );

                updateUrlWithVanity(result.vanity);

                return result.vanity;
            } catch (error) {
                console.error("Error fetching the vanity link data:", error);
            }

            return null;
        };

        if (props?.autoLogin && pathId.includes("autologin")) {
            const authenticateAutoLoginResult = async () => {
                try {
                    const result = await authenticateAutoLogin();
                    pathId = result;
                    setNoUsername(true);
                    setCurrentScreen("vanityAvatarScreen");
                } catch (error) {
                    console.error("Error during auto-login authentication:", error);
                }
            };
            authenticateAutoLoginResult();
        }

        const getVanityLinkData = async (pathId) => {
            if (window.location.pathname.includes("iframe")) {
                // Skip error handling for dcv-iframe.html
                return;
            }
            // Skip console routes - they are not vanity links
            if (window.location.pathname.startsWith("/console")) {
                return;
            }
            try {
                const { data, status } = await fetchVanityLinkData(pathId);

                if (status !== 200) {
                    window.location.replace(process.env.REACT_APP_HOME_PAGE_URL);
                }

                setVanityLinkData(data || {});
                dispatch(
                    SaveVanityLink(
                        data.clientLogo,
                        data.backgroundImage,
                        data.freeformJson,
                        data.clientName,
                        data.emailLogin,
                        data.spotifyLogin,
                        data.broadcast,
                        data.ambientTrack,
                        data.guestOnlyMode,
                        data.vanityLinkId
                    )
                );

                if (data.backgroundImage) {
                    const fileType = await getFileType(data.backgroundImage);
                    setBackgroundFileType(fileType);
                }

                setIsLoading(false);
            } catch (error) {
                if (window.location.pathname.includes("iframe")) {
                    // Skip error handling for dcv-iframe.html
                    return;
                }
                window.location.replace("/"); // will reload page if no vanity link found
                console.error("Error fetching the vanity link data:", error);
            }
        };

        if (pathId === "[object%20Object]") {
            return;
        }

        if (pathId.includes("autologin") === false) {
            getVanityLinkData(pathId);
        }
    }, [pathId]);

    useEffect(() => {
        if (googleSsoData || spotifySsoData) {
            let parsedData = null;
            let provider = "";
            if (spotifySsoData) {
                parsedData = JSON.parse(decodeURIComponent(spotifySsoData));
                provider = "spotify-vanity";
            }
            if (googleSsoData) {
                parsedData = JSON.parse(decodeURIComponent(googleSsoData));
                provider = "google-vanity";
            }
            const handleSSO = async () => {
                const {
                    email,
                    displayName,
                    token,
                    refreshToken,
                    userId,
                    userRoles,
                    isMerchant,
                    expiration,
                    isUserOwnerOfClient,
                } = parsedData;
                setSsoByPass(true);
                dispatch(
                    SaveUser(
                        email,
                        displayName,
                        token,
                        refreshToken,
                        userId,
                        userRoles[0],
                        isMerchant,
                        expiration,
                        "",
                        "",
                        isUserOwnerOfClient
                    )
                );
                localStorage.setItem("isSpotifyLogin", true);
                setToSessionStorage("token", token);
                setToSessionStorage("userId", userId);
                localStorage.setItem("justLoggedIn", true);
                const deviceInfo = await getDeviceInfo();
                const eventJson = {
                    user: parsedData,
                    clientName: pathId,
                };

                await sendEventsLog(token, pathId, userId, LOG_EVENTS_USER_LOGIN_DATA, provider, eventJson, "", "");

                await sendEventsLog(token, pathId, userId, LOG_EVENTS_DEVICE_DATA, "info-vanity", deviceInfo, "", "");

                setEmail(email);
                setLoginError("");
                const cleanUrl = `${window.location.origin}${window.location.pathname}`;
                window.history.replaceState({}, document.title, cleanUrl);

                const exists = await emailExistsChecker(email.toLowerCase());
                setEmailExists(exists);
                setCurrentScreen("vanityAvatarScreen");
            };
            handleSSO();
        }
    }, [googleSsoData, dispatch, spotifySsoData]);

    // sso update username
    useEffect(() => {
        if (ssoByPass && username) {
            const updateUserName = async () => {
                try {
                    await UpdateUserProfileData({
                        displayName: username,
                    });
                } catch (error) {
                    console.error("Error updating username:", error);
                }
            };
            updateUserName();
        }
    }, [ssoByPass, username]);

    // Handles login if user exists
    useEffect(() => {
        const fetchData = async () => {
            setIsLoading(true);
            try {
                const res = await LogInWithEmail(email, password, "", vanityLinkData.clientName);
                if (res.status === 200) {
                    const role = res.userRoles[0];
                    localStorage.setItem("justLoggedIn", true);
                    if (role === SUPERADMIN_ROLE || role === ADMIN_ROLE || res.isMerchant) {
                        if (res.isMerchant) {
                            const {
                                merchantName,
                                merchantId,
                                street,
                                city,
                                country,
                                postalCode,
                                merchantBusinessType,
                                stripeClientId,
                            } = res.merchant;
                            const address = { street, city, country, postalCode };

                            dispatch(
                                SaveMerchant(merchantName, merchantId, address, merchantBusinessType, stripeClientId)
                            );
                        }

                        if (res.userRoles[0] === SUPERADMIN_ROLE || res.userRoles[0] === ADMIN_ROLE || res.isMerchant) {
                            dispatch(
                                SaveUser(
                                    res.user.email,
                                    res.user.displayName,
                                    res.token,
                                    res.refreshToken,
                                    res.userId,
                                    res.userRoles[0],
                                    res.isMerchant,
                                    res.expiration,
                                    res.profileIconBase64,
                                    res.user.userBirthday,
                                    res.isUserOwnerOfClient
                                )
                            );
                        }
                    } else {
                        dispatch(
                            SaveUser(
                                res.user.email,
                                res.user.displayName,
                                res.token,
                                res.refreshToken,
                                res.userId,
                                "",
                                res.isMerchant,
                                res.expiration,
                                res.profileIconBase64,
                                res.user.userBirthday,
                                res.isUserOwnerOfClient
                            )
                        );
                    }
                    setNoUsername(true);
                    setCurrentScreen("vanityAvatarScreen");
                } else {
                    setLoginError("Failed to login, please ensure your information is correct");
                    setIsFormSubmitted(false);
                    setTimeout(() => {
                        setLoginError("");
                        // Clear error message after 10 seconds
                        // window.location.reload(); Not sure if we want to reload the page here
                    }, 10000);
                }
            } catch (error) {
                console.error("API call error:", error);
                setLoginError("Failed to login, please try again.");
                setTimeout(() => {
                    window.location.reload();
                }, 4000);
            } finally {
                setIsLoading(false);
            }
        };

        if (isFormSubmitted && !isEmailError && !isPasswordError && emailErrorMsg === "" && passwordErrorMsg === "") {
            fetchData();
        }
    }, [isFormSubmitted, isEmailError, isPasswordError, emailErrorMsg, passwordErrorMsg, email, password]);

    useEffect(() => {
        if (currentScreen === "vanityRedirect" && !isLoading) {
            // Resolve the room ID from the vanity slug before showing streaming screen
            const resolveRoomId = async () => {
                try {
                    // Basic UUID check. If it's a UUID, use it directly
                    const isUUID = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/.test(
                        pathId
                    );

                    if (isUUID) {
                        setResolvedRoomId(pathId);
                    } else {
                        // Otherwise, fetch the actual room ID from the vanity slug
                        const response = await fetchVanityLinkBySlug(pathId);
                        if (response?.data?.roomId) {
                            setResolvedRoomId(response.data.roomId);
                        } else {
                            console.error(`Could not resolve vanity slug: ${pathId}`);
                        }
                    }
                } catch (error) {
                    console.error(`Error fetching vanity link for slug ${pathId}:`, error);
                } finally {
                    // Proceed to streaming screen regardless of outcome
                    setCurrentScreen("vanityStreamingScreen");
                }
            };

            resolveRoomId();
        }
    }, [currentScreen, isLoading, pathId]);

    useEffect(() => {
        if (spotifyToken && !window.Spotify) {
            const script = document.createElement("script");
            script.src = "https://sdk.scdn.co/spotify-player.js";
            script.async = true;
            document.body.appendChild(script);
            window.onSpotifyWebPlaybackSDKReady = () => {};
        }
    }, [spotifyToken]);

    const sendPasswordResetEmail = async (e) => {
        setIsEmailError(false);
        setEmailErrorMsg("");
        setPasswordReset(true);

        if (email === "") {
            setIsEmailError(true);
            setEmailErrorMsg("Email is required");
        } else if (!isValidEmail(email)) {
            setIsEmailError(true);
            setEmailErrorMsg("Email must be a valid email address");
        }

        await forgotPasswordEmail(`${window.location.origin}/reset-password`, email);
    };

    const handleAvatarSelect = (avatar) => {
        setFinalAvatar(avatar);
    };

    // const validBirthdate = (current) => current.isBefore(moment());

    // const handleDateChange = (date) => {
    //     if (moment.isMoment(date)) {
    //         const today = moment();
    //         const age = today.diff(date, "years");

    //         if ((vanityLinkData.clientName === "bet-mgm" || vanityLinkData.clientName === "playstar") && age < 21) {
    //             setIsBirthdateErr(true);
    //             setBirthdateErrorMsg("You must be at least 21 years old to register.");
    //         } else if (age < 18) {
    //             setIsBirthdateErr(true);
    //             setBirthdateErrorMsg("You must be at least 18 years old to register.");
    //         } else {
    //             setIsBirthdateErr(false);
    //             setBirthdateErrorMsg("");
    //         }

    //         setBirthday(date.format("YYYY-MM-DD"));
    //     }
    // };

    const handleBirthdayInput = (e) => {
        let value = e.target.value.replace(/[^\d/]/g, "");

        if (value.includes("/")) {
            const parts = value.split("/");
            value = parts.join("");
        }

        if (value.length > 4) {
            value = `${value.slice(0, 2)}/${value.slice(2, 4)}/${value.slice(4)}`;
        } else if (value.length > 2) {
            value = `${value.slice(0, 2)}/${value.slice(2)}`;
        }

        value = value.slice(0, 10);

        setBirthday(value);

        let valid = /^\d{2}\/\d{2}\/\d{4}$/.test(value);

        if (valid) {
            const [dd, mm, yyyy] = value.split("/").map(Number);
            const now = new Date();
            const maxYear = now.getFullYear();

            if (yyyy < 1900 || yyyy > maxYear) valid = false;
            if (mm < 1 || mm > 12) valid = false;
            if (dd < 1 || dd > 31) valid = false;

            const dateObj = new Date(yyyy, mm - 1, dd);
            if (dateObj.getFullYear() !== yyyy || dateObj.getMonth() !== mm - 1 || dateObj.getDate() !== dd) {
                valid = false;
            }

            if (dateObj > now) valid = false;
        }

        setIsBirthdayInputValid(valid);
    };

    const handleRegisterSubmit = useCallback(async () => {
        setIsLoading(true);

        const spotifyToken = getFromSessionStorage("spotifyAccessToken");
        if (spotifyToken) {
            const player = new window.Spotify.Player({
                name: "Web Playback SDK",
                getOAuthToken: (cb) => cb(spotifyToken),
                volume: 0.3,
            });
            setSpotifyPlayer(player);
        }

        // SHARE URL
        if (inviteSettings !== null && isRoomInvite !== null) {
            const res = await RegisterGuestUser({
                email: email || getFromSessionStorage("email"),
                displayName: username,
                vanityLinkId: vanityLinkData.vanityLinkId,
                optInMarketing: specialOffers,
                clientName: vanityLinkData.clientName,
                guestOnlyMode: vanityLinkData.guestOnlyMode,
            });
            if (res && (res.userId || res.user?.userId)) {
                dispatch(
                    SaveUser(
                        res.user.email,
                        res.user.displayName,
                        res.token,
                        res.refreshToken,
                        res?.userId,
                        res.userRoles[0],
                        res.isMerchant,
                        res.expiration,
                        res.profileIconBase64,
                        res.user.userBirthday,
                        res.isUserOwnerOfClient
                    )
                );
                setToSessionStorage("token", res.token);
                setToSessionStorage("userId", res?.userId);
                localStorage.setItem("justLoggedIn", true);
                setLoginError("");

                const guestAvatarUserId = getFromSessionStorage("avatarUserId");
                const guestAvatarId = getFromSessionStorage("avatarId");

                if (res.userId && guestAvatarId && guestAvatarUserId) {
                    try {
                        await UpdateUserSettings(res.userId, guestAvatarId, guestAvatarUserId);
                        // Adds guest avatar account to userSettings
                    } catch (error) {
                        console.log(`error while updating userSettings: `, error);
                    }
                }
                await sendEventsLog(
                    res.token,
                    pathId,
                    res.userId,
                    LOG_EVENTS_AVATAR_SELECTION,
                    "info",
                    {
                        avatarpresetid: getFromSessionStorage("selectedAvatar"),
                    },
                    "",
                    ""
                );
            } else {
                setLoginError("Failed to login, please try again.");
            }
            setIsLoading(false);
            setCurrentScreen("vanityRedirect");
        }

        if (!vanityLinkData.guestOnlyMode) {
            let formattedBirthday = birthday;
            if (birthday !== "" && isBirthdayInputValid) {
                // reverse the birthday value to YYYY-MM-DD format
                const [dd, mm, yyyy] = formattedBirthday.split("/").map(Number);
                formattedBirthday = `${yyyy}-${String(mm).padStart(2, "0")}-${String(dd).padStart(2, "0")}`;
            }

            const res = await RegisterUser(
                firstName,
                lastName,
                email,
                password,
                username,
                formattedBirthday,
                specialOffers,
                "",
                pathId
            );
            if (res !== null) {
                dispatch(
                    SaveUser(
                        res.user.email,
                        res.user.displayName,
                        res.token,
                        res.refreshToken,
                        res?.userId,
                        "",
                        res.isMerchant,
                        res.expiration,
                        res.profileIconBase64,
                        res.user.userBirthday,
                        res.isUserOwnerOfClient
                    )
                );

                localStorage.setItem("justLoggedIn", true);
                setToSessionStorage("token", res.token);
                setToSessionStorage("userId", res?.userId);
                setLoginError("");
                const guestAvatarUserId = getFromSessionStorage("avatarUserId");
                const guestAvatarId = getFromSessionStorage("avatarId");

                if (res.userId && guestAvatarId && guestAvatarUserId) {
                    try {
                        await UpdateUserSettings(res.userId, guestAvatarId, guestAvatarUserId);
                    } catch (error) {
                        console.error(`error while updating userSettings: `, error);
                    }
                }
                setIsLoading(false);
                setCurrentScreen("vanityRedirect");
            }
        } else {
            const res = await RegisterGuestUser({
                email: email || getFromSessionStorage("email"),
                displayName: username,
                vanityLinkId: vanityLinkData.vanityLinkId,
                optInMarketing: specialOffers,
                clientName: vanityLinkData.clientName,
                guestOnlyMode: vanityLinkData.guestOnlyMode,
            });
            if (res && (res.userId || res.user?.userId)) {
                dispatch(
                    SaveUser(
                        res.user.email,
                        res.user.displayName,
                        res.token,
                        res.refreshToken,
                        res.userId,
                        res.userRoles[0],
                        res.isMerchant,
                        res.expiration,
                        res.profileIconBase64,
                        res.user.userBirthday,
                        res.isUserOwnerOfClient
                    )
                );
                setToSessionStorage("token", res.token);
                setToSessionStorage("userId", res.userId);
                localStorage.setItem("justLoggedIn", true);
                setLoginError("");
                const guestAvatarUserId = getFromSessionStorage("avatarUserId");
                const guestAvatarId = getFromSessionStorage("avatarId");

                if (res.userId && guestAvatarId && guestAvatarUserId) {
                    try {
                        await UpdateUserSettings(res.userId, guestAvatarId, guestAvatarUserId);
                    } catch (error) {
                        console.log(`error while updating userSettings: `, error);
                    }
                }
                sendEventsLog(
                    res.token,
                    pathId,
                    res.userId,
                    LOG_EVENTS_AVATAR_SELECTION,
                    "info",
                    {
                        avatarpresetid: getFromSessionStorage("selectedAvatar"),
                    },
                    "",
                    ""
                );
            } else {
                setLoginError("Failed to login, please try again.");
            }
            setIsLoading(false);
            setCurrentScreen("vanityRedirect");
        }
    }, [dispatch, email, firstName, lastName, password, specialOffers, username, vanityLinkData]);

    // Handles sending an email to the user for auto-login link
    const sendAutoLoginEmail = async () => {
        setIsEmailError(false);
        setPasswordReset(false);
        // Validate inputs
        if (!email || !pathId) {
            setIsEmailError(true);
            setEmailErrorMsg("There is no email or vanity path to send the email to. Please try again.");
            return;
        }

        try {
            const emailSent = await sendAutoLoginLink(email, pathId);

            if (!emailSent) {
                setIsEmailError(true);
                setEmailErrorMsg("Failed to send email, please try again or try another email.");
                return;
            }

            setSendEmail(true);
        } catch (error) {
            console.error("Error sending auto login email:", error);
            setIsEmailError(true);
            setEmailErrorMsg("An error occurred while trying to send the email. Please try again.");
        }
    };

    return (
        <>
            {/* <Banner
                width={"100%"}
                zIndex="1000"
                message={`${alreadyLoggedInMessage}`}
                type={"SUCCESS"}
                openBanner={!!alreadyLoggedInMessage}
                setOpenBanner={setAlreadyLoggedInMessage}
                topDisplay
                showCloseButton
                gameScreen={false}
                timer={5000}
                bottom={"20px"}
                left={"0"}
            /> */}
            {isLoading && (!vanityLinkData || Object.keys(vanityLinkData).length === 0) && (
                <Box
                    sx={{
                        width: "100%",
                        color: setColor.boxContainerBg,
                    }}
                >
                    <LinearProgress color="inherit" size="lg" />
                </Box>
            )}

            {currentScreen === "vanityStreamingScreen" &&
                !isLoading &&
                (isDcvStreaming ? (
                    <RoomSettingsProvider>
                        <RenderStreaming roomId={resolvedRoomId} />
                    </RoomSettingsProvider>
                ) : (
                    <VanityURLRedirects
                        pathId={pathId}
                        token={token || getFromSessionStorage("token")}
                        userId={userId || getFromSessionStorage("userId")}
                        spotifyPlayer={spotifyPlayer}
                        finalAvatar={finalAvatar}
                    />
                ))}

            {!isLoading && currentScreen !== "vanityRedirect" && currentScreen !== "vanityStreamingScreen" && (
                <BackgroundContainer
                    variant={backgroundFileType === "mp4" ? "CustomVideo" : "CustomImage"}
                    backgroundSize={"cover"}
                    backgroundImage={vanityLinkData.backgroundImage}
                    videoSource={vanityLinkData.backgroundImage}
                    backgroundColor={null}
                >
                    {currentScreen !== "vanityStartingPage" && <Overlay />}
                    {currentScreen === "vanityStartingPage" && (
                        <>
                            <PartnershipBannerContainer>
                                {/* <div>
                                    <IntraverseLogoBanner src={IntraverseLetteringLogo} alt="Intraverse Logo Icon" />
                                </div> */}
                                {vanityLinkData.clientLogo && (
                                    <>
                                        {/* <div>
                                            <XIcon src={XIconImg} alt="Close" />
                                        </div> */}
                                        <div>
                                            <PartnerLogo src={vanityLinkData.clientLogo} alt="Client Logo Icon" />
                                        </div>
                                    </>
                                )}
                            </PartnershipBannerContainer>

                            <GetStartedContainer onClick={() => setCurrentScreen("vanityEmailPage")}>
                                {vanityLinkData.miscImageKey && (
                                    <StyledMiscImage src={vanityLinkData.miscImageKey} alt="Client Logo Icon" />
                                )}
                                {!vanityLinkData.miscImageKey && <StyledPinkIntraverseLogoIcon />}
                                <StartingText>Get Started</StartingText>
                            </GetStartedContainer>
                        </>
                    )}

                    {currentScreen === "vanityEmailPage" && (
                        <>
                            {isAlreadyLoggedIn && user?.email && <h1> You are logged in as {user?.email}</h1>}
                            <EmailFormContainer guestOnlyMode={vanityLinkData.guestOnlyMode}>
                                {registerForm && (
                                    <Iconify
                                        style={{ position: "absolute", top: "20px", left: "20px", height: "50px" }}
                                        Color={setColor.accent4}
                                        onClick={() => setRegisterForm(false)}
                                        icon="material-symbols:arrow-back-ios"
                                    />
                                )}
                                <Iconify
                                    style={{
                                        position: "absolute",
                                        top: "20px",
                                        right: "20px",
                                        height: "50px",
                                        cursor: "pointer",
                                    }}
                                    Color={setColor.accent4}
                                    onClick={() => setCurrentScreen("vanityStartingPage")}
                                    icon="material-symbols:close"
                                />
                                {vanityLinkData.freeformJson?.emailTitle ? (
                                    <>
                                        <IntraverseLogo src={vanityLinkData.clientLogo} alt="Client Logo Icon" />
                                        <Typography
                                            style={{ fontWeight: 500, fontSize: "22px", marginBottom: "10px" }}
                                            variant={"pWhite"}
                                        >
                                            {vanityLinkData.freeformJson?.emailTitle}
                                        </Typography>
                                        {vanityLinkData.freeformJson?.emailSubtitle && (
                                            <Typography
                                                style={{ fontWeight: 200, fontSize: "18px", marginTop: 0 }}
                                                variant={"pWhite"}
                                            >
                                                {vanityLinkData.freeformJson?.emailSubtitle}
                                            </Typography>
                                        )}
                                    </>
                                ) : (
                                    <>
                                        <IntraverseLogo src={IntraverseLetteringLogo} alt="Intraverse Logo Icon" />
                                        <Typography style={{ fontWeight: 500, fontSize: "22px" }} variant={"pWhite"}>
                                            {emailExists
                                                ? "Welcome back! Follow the instructions below to play intraverse!"
                                                : vanityLinkData.guestOnlyMode && !emailExists
                                                  ? "Ready to play Intraverse? Start by entering your email."
                                                  : // ? "Enter your email to pick your avatar!"
                                                    "Ready to play Intraverse? Start by entering your email & select your password."}
                                        </Typography>
                                    </>
                                )}
                                {!registerForm && (
                                    <InputContainer>
                                        <Input
                                            variant="LoginInput"
                                            type="email"
                                            value={email.toLowerCase()}
                                            borderRadius="0px"
                                            onChangeHandler={handleEmailCheck}
                                            placeholder="Email"
                                            inputIcon={"ic:baseline-email"}
                                            inputIconColor={emailExists ? setColor.inputGreen : setColor.iconColor3}
                                            checkMarkIcon={emailExists ? "carbon:checkmark-filled" : undefined}
                                        />
                                        {isEmailError && <p style={{ color: setColor.errorColor }}>{emailErrorMsg}</p>}
                                        {(!vanityLinkData.guestOnlyMode || emailExists) && (
                                            <>
                                                <Input
                                                    variant="LoginInput"
                                                    borderRadius="0px"
                                                    type="password"
                                                    value={password}
                                                    inputIcon={"ri:key-fill"}
                                                    inputIconColor={setColor.iconColor3}
                                                    onChangeHandler={(event) => {
                                                        setPassword(event.target.value);
                                                    }}
                                                    placeholder="Password"
                                                />
                                                {!emailExists && (
                                                    <PasswordChecker
                                                        backgroundColor={"#0000007f"}
                                                        borderRadius={"2px"}
                                                        password={password}
                                                    />
                                                )}
                                                {isPasswordError !== null && (
                                                    <p style={{ color: setColor.errorColor }}>{passwordErrorMsg}</p>
                                                )}

                                                {!emailExists && (
                                                    <>
                                                        <DateInputContainer>
                                                            <BirthdayIconStyled
                                                                src={BirthdayIcon}
                                                                alt="Birthday Icon"
                                                            />
                                                            <TextBirthdayInput
                                                                type="text"
                                                                value={birthday || ""}
                                                                onChange={handleBirthdayInput}
                                                                placeholder="DD-MM-YYYY"
                                                            />
                                                        </DateInputContainer>
                                                        {isBirthdateErr !== null && (
                                                            <p style={{ color: setColor.errorColor }}>
                                                                {birthdateErrorMsg}
                                                            </p>
                                                        )}
                                                    </>
                                                )}
                                            </>
                                        )}
                                        {/* EMAIL EXISTS and NORMAL LOGIN MODE */}
                                        {emailExists && !vanityLinkData.guestOnlyMode && (
                                            <>
                                                {userAgeErr && (
                                                    <p style={{ color: setColor.errorColor }}>{userAgeErrMsg}</p>
                                                )}
                                                <p style={{ color: setColor.errorColor }}>{loginError}</p>
                                                <Button
                                                    onClick={() => setIsFormSubmitted(true)}
                                                    disabled={
                                                        !(isValidEmail(email) && password.length > 0 && !userAgeErr)
                                                    }
                                                    label="Jump In"
                                                    variant="VanityLinkCustomizable"
                                                />
                                                <div
                                                    style={{ color: "white", margin: "1rem 0" }}
                                                    label="Forgot Password"
                                                    onClick={() => {
                                                        setLoginError(
                                                            "Email Sent! Check your email to reset password."
                                                        );
                                                        sendPasswordResetEmail();
                                                    }}
                                                >
                                                    Forgot Password
                                                </div>
                                            </>
                                        )}
                                        {/* EMAIL DOESNT EXIST and NORMAL LOGIN MODE to avatar selection */}
                                        {!emailExists && !vanityLinkData.guestOnlyMode && (
                                            <>
                                                <CheckboxContainer style={{ margin: "10px 0" }}>
                                                    <div style={{ display: "flex", flexDirection: "row" }}>
                                                        <CheckBoxMain
                                                            checked={checkboxStatus}
                                                            onChange={() =>
                                                                setCheckboxStatus((checkboxStatus) => !checkboxStatus)
                                                            }
                                                        />
                                                        <Typography
                                                            style={{
                                                                fontSize: "16px",
                                                                margin: "0.3rem 10px 0.3rem 16px",
                                                            }}
                                                            variant={"pWhite"}
                                                            align={"left"}
                                                        >
                                                            I am at least{" "}
                                                            {vanityLinkData.clientName === "bet-mgm" ||
                                                            vanityLinkData.clientName === "playstar"
                                                                ? " 21 "
                                                                : " 18 "}
                                                            years old and I agree to Intraverse's{" "}
                                                            <TermsLink
                                                                href="https://terrazero.com/privacy-policy"
                                                                target="_blank"
                                                                rel="noreferrer"
                                                            >
                                                                {" "}
                                                                Privacy Policy
                                                            </TermsLink>{" "}
                                                            and{" "}
                                                            <TermsLink
                                                                href="https://terrazero.com/privacy-policy"
                                                                target="_blank"
                                                                rel="noreferrer"
                                                            >
                                                                {" "}
                                                                Terms & Conditions.
                                                            </TermsLink>
                                                        </Typography>
                                                    </div>
                                                </CheckboxContainer>
                                                {vanityLinkData.marketingOptIn && (
                                                    <CheckboxContainer>
                                                        <CheckBoxMain
                                                            checked={specialOffers}
                                                            onChange={() =>
                                                                setSpecialOffers((specialOffers) => !specialOffers)
                                                            }
                                                            labelTextRight="Recieve news, special offers, event information and feedback surveys by email from intraverse"
                                                        />
                                                    </CheckboxContainer>
                                                )}
                                                {isCheckboxError && (
                                                    <p style={{ color: setColor.errorColor }}>{checkboxErrorMsg}</p>
                                                )}
                                                <Button
                                                    onClick={handleEmailData}
                                                    variant={
                                                        passwordErrorMsg === "" &&
                                                        emailErrorMsg === "" &&
                                                        checkboxStatus &&
                                                        isBirthdateErr === false
                                                            ? "VanityLinkCustomizable"
                                                            : "DisabledButton"
                                                    }
                                                    label="Continue to Register"
                                                    disabled={
                                                        passwordErrorMsg !== "" ||
                                                        emailErrorMsg !== "" ||
                                                        !checkboxStatus ||
                                                        isBirthdateErr === true ||
                                                        !isBirthdayInputValid
                                                    }
                                                />
                                            </>
                                        )}

                                        {/* EMAIL DOESNT EXIST and GUEST MODE ON to avatar selection */}
                                        {!emailExists && vanityLinkData.guestOnlyMode && (
                                            <>
                                                {vanityLinkData.marketingOptIn && (
                                                    <CheckboxContainer>
                                                        <CheckBoxMain
                                                            checked={specialOffers}
                                                            onChange={() =>
                                                                setSpecialOffers((specialOffers) => !specialOffers)
                                                            }
                                                            labelTextRight="Recieve news, special offers, event information and feedback surveys by email from intraverse"
                                                        />
                                                    </CheckboxContainer>
                                                )}
                                                <CheckboxContainer style={{ width: "100%", color: "white" }}>
                                                    <div style={{ display: "flex", flexDirection: "row" }}>
                                                        <CheckBoxMain
                                                            checked={checkboxStatus}
                                                            style={{ margin: "1rem" }}
                                                            onChange={() =>
                                                                setCheckboxStatus((checkboxStatus) => !checkboxStatus)
                                                            }
                                                        />
                                                        <Typography
                                                            style={{
                                                                fontSize: "16px",
                                                                margin: "0.3rem 10px 0.3rem 16px",
                                                            }}
                                                            variant={"pWhite"}
                                                            align={"left"}
                                                        >
                                                            I am at least 18 years old and I agree to Intraverse's{" "}
                                                            <TermsLink
                                                                href="https://terrazero.com/privacy-policy"
                                                                target="_blank"
                                                                rel="noreferrer"
                                                            >
                                                                {" "}
                                                                Privacy Policy
                                                            </TermsLink>{" "}
                                                            and{" "}
                                                            <TermsLink
                                                                href="https://terrazero.com/privacy-policy"
                                                                target="_blank"
                                                                rel="noreferrer"
                                                            >
                                                                {" "}
                                                                Terms & Conditions.
                                                            </TermsLink>
                                                        </Typography>
                                                    </div>
                                                </CheckboxContainer>
                                                {isCheckboxError && (
                                                    <p style={{ color: setColor.errorColor }}>{checkboxErrorMsg}</p>
                                                )}
                                                {loginError && (
                                                    <p style={{ color: setColor.errorColor }}>{loginError}</p>
                                                )}
                                                {spotifyError && (
                                                    <p style={{ color: setColor.errorColor, margin: "1rem 0" }}>
                                                        {spotifyError}
                                                    </p>
                                                )}
                                                <Button
                                                    id="avatar-selection-button"
                                                    // type="button"
                                                    variant={
                                                        !checkboxStatus || !isValidEmail(email)
                                                            ? "DisabledButton"
                                                            : "VanityLinkCustomizable"
                                                    }
                                                    label="Continue to Avatar Selection"
                                                    onClick={handleGuestUserData}
                                                />
                                                {/* NEED TO IMPLEMENT IN NEW TICKET:
                                            <Typography style={{ color: setColor.accent4 }} variant="UsernameSubtitle">
                                                I'm under 18 years old{' '}
                                            </Typography> */}
                                            </>
                                        )}
                                        {emailExists && vanityLinkData.guestOnlyMode && (
                                            <>
                                                {emailExists && (
                                                    <>
                                                        {loginError && (
                                                            <p style={{ color: setColor.errorColor }}>{loginError}</p>
                                                        )}
                                                        <Button
                                                            variant="VanityLinkCustomizable"
                                                            backgroundColor="transparent"
                                                            disabled={!isValidEmail(email)}
                                                            label="Login With Password"
                                                            onClick={() => {
                                                                setIsFormSubmitted(true);
                                                            }}
                                                        />
                                                    </>
                                                )}
                                                <Button
                                                    variant="VanityLinkCustomizable"
                                                    disabled={!isValidEmail(email)}
                                                    label="Quick Login Link"
                                                    onClick={() => sendAutoLoginEmail()}
                                                />
                                                <div
                                                    style={{ color: "white", margin: "1rem 0" }}
                                                    label="Forgot Password"
                                                    onClick={() => sendPasswordResetEmail()}
                                                >
                                                    Forgot Password
                                                </div>

                                                {(sendEmail || passwordReset) && (
                                                    <CheckboxContainer style={{ width: "100%", color: setColor.white }}>
                                                        <Typography
                                                            variant={"h2PurpleHeading"}
                                                            margin={"0.2rem"}
                                                            style={{ textAlign: "left", fontSize: "18px" }}
                                                        >
                                                            Check Your Inbox!
                                                        </Typography>
                                                        <br />
                                                        {passwordReset
                                                            ? "Password reset email sent successfully. Please check your inbox."
                                                            : "Click on the link we sent to this email to continue your session in intraverse"}
                                                    </CheckboxContainer>
                                                )}
                                            </>
                                        )}
                                        {vanityLinkData.googleLogin && (
                                            <>
                                                <AuthSocial
                                                    vanityLinkData={vanityLinkData}
                                                    SsoProvider={"google"}
                                                    origin={"vanity"}
                                                />
                                            </>
                                        )}
                                        {vanityLinkData.spotifyLogin && (
                                            <>
                                                <AuthSocial
                                                    vanityLinkData={vanityLinkData}
                                                    SsoProvider={"spotify"}
                                                    origin={"vanity"}
                                                />
                                            </>
                                        )}
                                    </InputContainer>
                                )}

                                {registerForm && (
                                    <InputContainer>
                                        <Input
                                            variant="LoginInput"
                                            type="name"
                                            borderRadius="0px"
                                            value={firstName}
                                            onChangeHandler={(e) => setFirstName(e.target.value)}
                                            placeholder="First Name"
                                        />
                                        <Input
                                            variant="LoginInput"
                                            borderRadius="0px"
                                            type="name"
                                            value={lastName}
                                            onChangeHandler={(e) => setLastName(e.target.value)}
                                            placeholder="Last Name"
                                        />
                                        {/* DO NOT REMOVE COMMENTED CODE - New ticket will add these inputs later
                                    <Input
                                        variant="LoginInput"
                                        borderRadius="0px"
                                        type="date"
                                        value={birthday}
                                        onChangeHandler={(e) => setBirthday(e.target.value)}
                                        placeholder="Birthday"
                                    /> */}
                                        {/* <GenderSelect value={gender} onChange={(e) => setGender(e.currentTarget.value)}>
                                        <option value="" disabled hidden>
                                            How do you identify?
                                        </option>
                                        {genderOptions.map((gender) => (
                                            <option key={gender} value={gender}>
                                                <p style={{ margin: '5px', width: '100px' }}> {gender}</p>
                                            </option>
                                        ))}
                                    </GenderSelect>
                                    <GenderSelect value={country} onChange={(e) => setCountry(e.target.value)}>
                                        <option value="" disabled hidden>
                                            Where do you live?
                                        </option>
                                        {stripeCountries.map((countryObj) => (
                                            <option key={countryObj.code} value={countryObj.country}>
                                                {countryObj.country}
                                            </option>
                                        ))}
                                    </GenderSelect> */}
                                        {isNameError && (
                                            <p style={{ color: setColor.errorColor, alignSelf: "flex-start" }}>
                                                {nameError}
                                            </p>
                                        )}
                                        <Button
                                            variant={
                                                !nameValidation(firstName, lastName) ||
                                                !firstName.length > 0 ||
                                                !lastName.length > 0
                                                    ? "DisabledButton"
                                                    : "VanityLinkCustomizable"
                                            }
                                            label="Continue to final step"
                                            onClick={handleRegistrationDataSubmit}
                                        />
                                        <Button
                                            onClick={() => {
                                                setCurrentScreen("vanityAvatarScreen");
                                                setRegisterForm(false);
                                            }}
                                            variant="VanityLinkCustomizable"
                                            label="Skip for now"
                                        />
                                    </InputContainer>
                                )}
                            </EmailFormContainer>
                        </>
                    )}
                    {!isLoading && currentScreen === "vanityAvatarScreen" && (
                        <VanityAvatarPage
                            source={"vanityAvatarPage"}
                            setUsername={setUsername}
                            username={username}
                            setCurrentScreen={setCurrentScreen}
                            noUsername={noUsername}
                            vanityLink={pathId}
                            handleRegisterSubmit={handleRegisterSubmit}
                            onAvatarSelect={handleAvatarSelect}
                            ssoByPass={ssoByPass}
                        />
                    )}
                </BackgroundContainer>
            )}
        </>
    );
};

VanityStartingPage.propTypes = {
    autoLogin: PropTypes.bool,
};

export default VanityStartingPage;

const StyledPinkIntraverseLogoIcon = styled(PinkIntraverseLogoIcon)`
    height: 100px;
    @media (max-width: 960px) {
        height: 75px;
    }
`;

const StyledMiscImage = styled.img`
    width: 50%;
`;

const Overlay = styled.div`
    background: ${setColor.containerGradient};
    backdrop-filter: blur(100px);
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
    overflow-y: auto;

    @media (max-width: 960px) {
        height: 100vh;
        width: 100vw;
    }
`;
const CheckboxContainer = styled.div`
    background: ${setColor.purpleDark};
    font-family: ${setFont.barlow};
    padding: 1rem;
    margin: 0.3rem 0;
`;

const IntraverseLogo = styled.img`
    max-width: 230px;
    width: 80%;
    z-index: 1000;
`;

const EmailFormContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: ${(props) => (props.guestOnlyMode ? "center" : "flex-start")};
    align-items: center;
    height: 80%;
    width: 100%;
    z-index: 1;

    @media (max-width: 960px) {
        width: 100%;
        justify-content: flex-start;
    }
`;

const StartingText = styled.h1`
    color: ${setColor.hightlight};
    text-align: center;
    /* -webkit-text-stroke: 3px rgba(27, 27, 35, 0.5); */
    font-family: ${setFont.barlow};
    font-size: 32px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    letter-spacing: 3.6px;
    text-transform: uppercase;
    margin-top: 45px;

    @media (max-width: 960px) {
        font-size: 20px;
        margin-top: 25px;
    }
`;

const GetStartedContainer = styled.div`
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 5;
    flex-direction: column;
    width: 310px;
    height: 315px;
    flex-shrink: 0;

    border-radius: 10px;
    background: ${setColor.startedContainer};

    box-shadow: 0px 0px 60px 0px ${setColor.boxShadowContainer};
    backdrop-filter: blur(30px);

    @media (max-width: 960px) {
        margin-top: 55px;
        width: 220px;
        height: 205px;
    }
`;

const PartnershipBannerContainer = styled.div`
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    position: fixed;
    top: 0;
    width: auto;
    height: 75px;
    padding: 0 80px;
    background: ${setColor.startedContainer};
    box-shadow: 0px 0px 60px 0px ${setColor.boxShadowContainer};
    backdrop-filter: blur(30px);
    clip-path: polygon(0 0, 100% 0, 90% 100%, 10% 100%);

    @media (max-width: 960px) {
        height: 55px;
    }

    @media (max-width: 425px) {
        height: fit-content;
        width: 260px;
        top: 0px;
        padding: 0.5rem 0rem;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
`;
const IntraverseLogoBanner = styled.img`
    width: auto;
    height: 35px;

    @media (max-width: 960px) {
        height: 22px;
    }
`;
const PartnerLogo = styled.img`
    width: auto;
    max-width: 200px;
    height: auto;
    max-height: 35px;
    object-fit: fill;

    @media (max-width: 960px) {
        height: 20px;
    }

    @media (max-width: 425px) {
        margin: 0;
        height: 20px;
        width: auto;
    }
`;

const XIcon = styled.img`
    width: 15px;
    height: 15px;
    margin: 0 30px;

    @media (max-width: 960px) {
        margin: 0 20px;
    }

    @media (max-width: 425px) {
        margin: 10px 0;
    }
`;

const InputContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 550px;

    @media (max-width: 960px) {
        width: 70vw;
        padding-bottom: 25px;
    }

    @media (max-width: 425px) {
        width: 85vw;
        padding-bottom: 25px;
    }
`;

const TermsLink = styled.a`
    color: ${setColor.spanTextColor};
    font-weight: 700;
    text-decoration: none;
`;

// UNCOMENT TO IMPLEMENT ADDED FIELDS IN NEW TICKET:
// const GenderSelect = styled.select`
//     flex: 1;
//     background: ${setColor.inputBgColor};
//     border: 2px solid ${setColor.loadingButtonBg};
//     border-radius: 0px;
//     outline: none;
//     padding: 0.5rem 1rem;
//     margin: 0.5rem 0rem;
//     font-size: 18px;
//     font-style: italic;
//     font-family: 'Barlow', sans-serif;
//     color: ${setColor.iconColor};
//     width: 100%;
//     height: 70px;
// `;

const DateInputContainer = styled.div`
    position: relative;
    flex-direction: row;
    -webkit-box-align: center;
    align-items: center;
    background: rgb(27, 27, 35);
    border: 2px solid rgb(80, 76, 92);
    border-radius: 0px;
    width: 100%;
    height: 45px;
    margin: 1rem 0rem;
`;

const BirthdayIconStyled = styled.img`
    position: absolute;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
    width: 20px;
    height: 20px;
    pointer-events: none;
    user-select: none;
`;

const CustomDatetime = styled(Datetime)`
    .rdtDisabled {
        cursor: not-allowed !important;
        color: #ccc;
    }

    .rdt {
        background: rgb(27, 27, 35);
    }

    .rdtPicker {
        background: rgb(27, 27, 35);
        width: 100%;
        color: ${setColor.inputText};
    }

    .rdtDays,
    .rdtTime {
        background: rgb(27, 27, 35);
    }

    .rdtDay,
    .rdtMonth,
    .rdtPrev,
    .rdtNext,
    .rdtPicker th,
    .rdtYear {
        color: ${setColor.inputText};
        &:hover {
            color: black;
            background-color: ${setColor.grey1};
            cursor: pointer;
        }
    }

    input {
        padding: 10px 10px 10px 40px;
        color: ${setColor.inputText};
        width: 100%;
        background-color: transparent;
        border: 0px solid transparent;
        margin: 0;
        margin-bottom: ${(props) => (props.errorMessage ? "0.5rem" : "0rem")};
        outline: none;
        box-shadow: none;
        &:disabled {
            background-color: ${setColor.grey1};
        }
    }
`;

const TextBirthdayInput = styled.input`
    padding: 10px 10px 10px 40px;
    color: white;
    width: 100%;
    background-color: transparent;
    border: 0px solid transparent;
    outline: none;
`;
